import React from 'react';
import { useWizard } from 'src/pages/Automations/components/wizard/WizardContext';
import { ProviderSelect } from './ProviderSelect';
import { Option } from 'src/components/SelectBox';
import { AutoCompleteInput } from 'src/components/AutoCompleteInput';
import useAuthedRequest from 'src/hooks/useAuthedRequest';
import { Label } from 'src/components/Label';

export interface SmsProviderSelectionProps {
  onChange: (providerOption: { value: string; label: string }) => void;
  isAuthenticated?: boolean;
}

export const SmsProviderSelect: React.FC<SmsProviderSelectionProps> = ({
  onChange,
  isAuthenticated = false,
}) => {
  const { smsProviders, campaignAutomation, setCampaignAutomation } =
    useWizard();
  const { get, remove } = useAuthedRequest();

  const handleChange = (option: Option) => {
    onChange({
      value: option.value,
      label: option.label || option.value,
    });
  };

  const fetchLastNumbers = async (search: string) => {
    try {
      const data = await get(`/numbers/recent?number=${search}`);
      return data.map((i: { id: string; number: string }) => ({
        id: i.id,
        label: i.number,
        value: i.number,
      }));
    } catch (error) {
      console.error('Failed to fetch last numbers:', error);
      return [];
    }
  };

  const handleFromNumberChange = (value: string) => {
    setCampaignAutomation({
      ...campaignAutomation,
      smsFromNumber: value,
    });
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div>
        <Label
          className="text-sm font-medium text-neutral-700 mb-2 block"
          required
        >
          Select SMS provider
        </Label>
        <ProviderSelect
          providers={smsProviders}
          selectedProvider={campaignAutomation.smsProviderOption}
          onChange={handleChange}
          isAuthenticated={isAuthenticated}
          label=""
          htmlFor="sms-provider"
          className="w-full bg-neutral-0"
        />
      </div>

      {isAuthenticated && (
        <div className="w-full sm:w-80 flex-shrink-0 mt-4">
          <AutoCompleteInput
            label="From Number"
            id="sms-from"
            placeholder="Enter sender number (e.g., +15551234567)"
            value={campaignAutomation.smsFromNumber || ''}
            onChange={handleFromNumberChange}
            onRemove={(value) => remove(`/numbers/recent/${value}`)}
            required
            fetchOptions={fetchLastNumbers}
          />
        </div>
      )}
    </div>
  );
};
